import { h } from "preact";
import { Link } from "preact-router/match";

export default function Notfound() {
  return <div>Not found</div>;
}
